import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

export default {
  getProspectCustomerList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/landlord/marketing/prospect-customers?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  deployeDemoTenant(id) {
    return Repository.post(`/landlord/marketing/prospect-customer/${id}/deploy`)
  },
  changePartnerStatus(id, status) {
    return Repository.put(`/landlord/marketing/prospect-customer/${id}/${status}`)
  },
  getDemoPortalToken(id) {
    return Repository.get(`/landlord/marketing/prospect-customer/${id}/get-demo-tenant-token`)
  },
  createProspectCustomer(payload) {
    return Repository.post(`/landlord/marketing/prospect-customers`, payload)
  },
  updateProspectCustomer(id, payload) {
    return Repository.put(`/landlord/marketing/prospect-customers/${id}`, payload)
  },
  getProspectCustomer(id) {
    return Repository.get(`/landlord/marketing/prospect-customers/${id}`)
  },
}
